import { Component, ViewEncapsulation, inject } from '@angular/core';
import { ModalInjectableData } from '@rogers/cdk/common/classes';
import { ModalRef, ModalModule } from '@rogers/cdk/modal';
import { UserAccount } from '@rogers/self-serve-common/account';
import { NgTemplateOutlet } from '@angular/common';
import { ChipComponent } from '@rogers/cdk/chip';
import { LabelComponent } from '@rogers/cdk/label';
import { IconComponent } from '@rogers/cdk/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'fss-account-selector-modal',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./account-selector-modal.component.scss'],
  templateUrl: './account-selector-modal.component.html',
  imports: [ModalModule, NgTemplateOutlet, ChipComponent, LabelComponent, IconComponent, TranslatePipe],
})
export class AccountSelectorModalComponent {
  private readonly modalRef = inject(ModalRef);

  readonly accounts: UserAccount[];

  constructor() {
    const modalData = inject(ModalInjectableData);

    this.accounts = modalData.source.accounts;
  }

  selectAccount(selectedAccountNumber: string) {
    this.modalRef.close(selectedAccountNumber);
  }
}
